import { createSelector } from '@ngrx/store';

export const selectOrdenCompraState = (state: { ordenesCompra: any }) =>
  state.ordenesCompra;

export const selectDatosAnteriores = createSelector(
  selectOrdenCompraState,
  ordenCompra => ordenCompra.datosAnteriores,
);

export const selectDatosSiguientes = createSelector(
  selectOrdenCompraState,
  ordenCompra => ordenCompra.datosSiguientes,
);

export const selectOrdenesCompraPendientes = createSelector(
  selectOrdenCompraState,
  ordenCompra => ordenCompra.pendientes,
);
